import {useMutation} from "@tanstack/react-query";

import {errorHandler} from "@/src/modules/core/lib";

import {authService} from "../services";
import {ResetRequest} from "../types";

export default function useReset() {
  return useMutation({
    mutationFn: (data: ResetRequest) => authService.reset(data),
    retry: false,
    onError: errorHandler,
  });
}
